"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilteringRequest = void 0;

var _clientRequest = require("./client-request");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * An abstract base for client requests that filter messages by certain criteria.
 *
 * @abstract
 *
 * @template <B> the type of the builder wrapped by this request
 * @template <T> the type of the messages that store the request data
 */
var FilteringRequest = /*#__PURE__*/function (_ClientRequest) {
  _inherits(FilteringRequest, _ClientRequest);

  var _super = _createSuper(FilteringRequest);

  /**
   * @param {!Class<Message>} targetType the target type of the request
   * @param {!Client} client the client which initiated the request
   * @param {!ActorRequestFactory} actorRequestFactory the request factory
   *
   * @protected
   */
  function FilteringRequest(targetType, client, actorRequestFactory) {
    var _this;

    _classCallCheck(this, FilteringRequest);

    _this = _super.call(this, client, actorRequestFactory);
    _this.targetType = targetType;
    return _this;
  }
  /**
   * Adds filtering by IDs to the built request.
   *
   * @param ids {!Message|Number|String|Message[]|Number[]|String[]}
   *        the IDs of interest
   * @return {this} self for method chaining
   */


  _createClass(FilteringRequest, [{
    key: "byId",
    value: function byId(ids) {
      ids = FilteringRequest._ensureArray(ids);

      this._builder().byIds(ids);

      return this._self();
    }
    /**
     * Adds filtering by predicates to the built request.
     *
     * Filters specified in a list are considered to be joined using `AND` operator.
     *
     * @param {!Filter|CompositeFilter|Filter[]|CompositeFilter[]} predicates the filters
     * @return {this} self for method chaining
     */

  }, {
    key: "where",
    value: function where(predicates) {
      predicates = FilteringRequest._ensureArray(predicates);

      this._builder().where(predicates);

      return this._self();
    }
    /**
     * Applies a field mask to the request results.
     *
     * The names of the fields must be formatted according to the `google.protobuf.FieldMask`
     * specification.
     *
     * @param {!String|String[]} fieldPaths the fields to include in the mask
     * @return {this} self for method chaining
     */

  }, {
    key: "withMask",
    value: function withMask(fieldPaths) {
      fieldPaths = FilteringRequest._ensureArray(fieldPaths);

      this._builder().withMask(fieldPaths);

      return this._self();
    }
    /**
     * Returns the builder for messages that store request data.
     *
     * @return {AbstractTargetBuilder<Message>} the builder instance
     *
     * @protected
     */

  }, {
    key: "_builder",
    value: function _builder() {
      if (!this._builderInstance) {
        var newBuilderFn = this._newBuilderFn();

        this._builderInstance = newBuilderFn(this._requestFactory);
      }

      return this._builderInstance;
    }
    /**
     * @callback _NewBuilderFn
     *
     * @param {ActorRequestFactory}
     * @return {AbstractTargetBuilder}
     */

    /**
     * Returns the function with which the {@link _builderInstance} can be created.
     *
     * @abstract
     * @return {_NewBuilderFn}
     *
     * @protected
     */

  }, {
    key: "_newBuilderFn",
    value: function _newBuilderFn() {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * @abstract
     * @return {this}
     *
     * @protected
     */

  }, {
    key: "_self",
    value: function _self() {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * Wraps the passed argument into array if it's not an array already.
     *
     * The `null` values are converted into an empty array.
     *
     * @return {Array} the passed argument as an array
     *
     * @private
     */

  }], [{
    key: "_ensureArray",
    value: function _ensureArray(values) {
      if (!values) {
        return [];
      }

      if (!(values instanceof Array)) {
        return [values];
      }

      return values;
    }
  }]);

  return FilteringRequest;
}(_clientRequest.ClientRequest);

exports.FilteringRequest = FilteringRequest;
//# sourceMappingURL=filtering-request.js.map